// extracted by mini-css-extract-plugin
export default {"fileForReview":"file-for-review-label_fileForReview__B3zc5"};